"use client";

import Image from "next/image";
import { Breadcrumb } from "@/components";

import type { TopBannerProps } from "@/types/top-banner.types";

export default function TopBanner({
	title,
	breadcrumb,
	displayBorder = true,
	isArticle = false,
}: TopBannerProps) {
	return (
		<section
			className={`spaced-between
				border-dividerSilent
				bg-layoutContainer
				relative
				${displayBorder && "border-b"}
				${isArticle ? "h-max pt-10" : "h-[152px]"}
				`}
		>
			<div
				className={`page-content flex items-center px-3 md:px-0 ${isArticle ? "h-max" : "h-[152px]"}`}
			>
				<div className="grow pb-1">
					<Breadcrumb crumbs={breadcrumb} />
					<h1
						className={`hmc-title-xl text-systemInfo ${isArticle && "md:w-2/3"}`}
						data-testid="top-banner-title"
					>
						{title}
					</h1>
				</div>
			</div>
		</section>
	);
}
